import React from "react";
import OracleNotificationFabric from "@/components/predictor/OracleNotificationFabric";
import ComplianceLock from "@/components/compliance/ComplianceLock";

/**
 * AdminOne · Notification Fabric (Phase 27H).
 */
export default function AdminNotificationFabric() {
  return (
    <div style={S.canvas} data-testid="admin-notification-fabric">
      <ComplianceLock variant="banner" policy="v27" testid="admin-notif-compliance-top" />
      <header style={S.header}>
        <div>
          <h1 style={S.title}>Multi-Device Notification Fabric™</h1>
          <p style={S.subtitle}>
            Honest channel status: each channel reports configured / awaiting provider key.
            Slack uses the existing AdminOne pipeline; others are placeholders until credentials are wired.
          </p>
        </div>
      </header>
      <div style={S.body}>
        <OracleNotificationFabric testid="admin-notif-fabric" />
      </div>
    </div>
  );
}

const S = {
  canvas: { minHeight: "100vh", background: "radial-gradient(circle at bottom left, rgba(197,160,89,0.10), #040608 30%, #020304 100%)", color: "#f8fafc", fontFamily: "'Figtree', 'Inter', system-ui, sans-serif" },
  header: { padding: "20px 26px 16px", borderBottom: "1px solid rgba(255,255,255,0.05)" },
  title: { color: "#c5a059", fontSize: 24, margin: 0, fontWeight: 800 },
  subtitle: { color: "#94a3b8", fontSize: 13, marginTop: 6, maxWidth: 820 },
  body: { padding: "16px 26px 30px" },
};
